module.exports = __webpack_public_path__ + "img/DOT51.a6bd87a7.png";